import React, { useState } from 'react';
import './PricingSection.css';

function PricingSection() {
  const [loading, setLoading] = useState(null); // Track which button is loading
  const [error, setError] = useState(null);
  const [customAmounts, setCustomAmounts] = useState({});

  const handleBuyClick = async (product) => {
    setError(null);
    setLoading(product.id);
    
    let amount = product.price;
    const productName = product.name;
    const username = 'guest'; // TODO: Replace with actual logged-in username
    const source = 'digitaladsconsultant.com';

    // Handle custom amount for products without fixed price
    if (amount === null) {
      const customAmount = customAmounts[product.id];
      const numericAmount = parseFloat(customAmount);
      
      if (!customAmount || isNaN(numericAmount) || numericAmount < 10 || numericAmount > 20000) {
        setError('Please enter an amount between RM 10 and RM 20,000');
        setLoading(null);
        return;
      }
      amount = numericAmount;
    }

    try {
      console.log('Sending payment request:', { amount, username, productName, source });
      
      const response = await fetch('/api/create-payment', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          amount: Number(amount), // Ensure amount is a number
          username, 
          productName, 
          source 
        })
      });

      const data = await response.json();
      console.log('Payment response:', response.status, data);

      if (response.ok && data.invoiceUrl) {
        // Redirect to Xendit invoice URL
        window.location.href = data.invoiceUrl;
      } else {
        setError(data.error || 'Failed to create payment. Please try again.');
      }
    } catch (error) {
      console.error('Payment error:', error);
      setError('Network error. Please check your connection and try again.');
    } finally {
      setLoading(null);
    }
  };

  const handleCustomAmountChange = (productId, value) => {
    setCustomAmounts(prev => ({
      ...prev,
      [productId]: value
    }));
    // Clear error when user starts typing
    if (error) setError(null);
  };

  // Example product data (replace with your actual products/pricing)
  const products = [
    { id: 1, name: 'Basic Package', price: 100, description: 'Ideal for small businesses.' },
    { id: 2, name: 'Standard Package', price: 250, description: 'More features for growing businesses.' },
    { id: 3, name: 'Premium Package', price: 500, description: 'Advanced solutions for large enterprises.' },
    { id: 4, name: 'Advertising Fees (Custom)', price: null, description: 'Enter your desired amount.' },
  ];

  return (
    <section className="pricing-section">
      <h2>Our Pricing</h2>
      
      {error && (
        <div className="error-banner">
          <p>{error}</p>
          <button onClick={() => setError(null)}>×</button>
        </div>
      )}
      
      <div className="pricing-cards-container">
        {products.map(product => (
          <div key={product.id} className="pricing-card">
            <h3>{product.name}</h3>
            <p className="price">
              {product.price ? `RM ${product.price}` : 'Custom Amount'}
            </p>
            <p>{product.description}</p>
            
            {product.price === null && (
              <div className="custom-amount-container">
                <input
                  type="number"
                  min="10"
                  max="20000"
                  step="0.01"
                  placeholder="Enter amount (RM)"
                  value={customAmounts[product.id] || ''}
                  onChange={(e) => handleCustomAmountChange(product.id, e.target.value)}
                  className="custom-amount-input"
                  disabled={loading === product.id}
                />
                <small>Min: RM 10, Max: RM 20,000</small>
              </div>
            )}
            
            <button 
              onClick={() => handleBuyClick(product)}
              disabled={loading === product.id}
              className={`buy-button ${loading === product.id ? 'loading' : ''}`}
            >
              {loading === product.id ? (
                <span className="loading-text">Processing...</span>
              ) : (
                'Buy Now'
              )}
            </button>
          </div>
        ))}
      </div>
      
      <style jsx>{`
        .error-banner {
          background-color: #fee;
          color: #c33;
          padding: 12px 16px;
          border-radius: 4px;
          margin-bottom: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .error-banner button {
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
          color: #c33;
        }
        
        .custom-amount-container {
          margin: 15px 0;
        }
        
        .custom-amount-input {
          width: 100%;
          padding: 10px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 16px;
          margin-bottom: 5px;
        }
        
        .custom-amount-input:disabled {
          background-color: #f5f5f5;
          cursor: not-allowed;
        }
        
        .buy-button {
          transition: all 0.3s ease;
          cursor: pointer;
        }
        
        .buy-button:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }
        
        .buy-button.loading {
          position: relative;
        }
        
        .loading-text {
          display: inline-block;
        }
        
        small {
          color: #666;
          font-size: 12px;
        }
      `}</style>
    </section>
  );
}

export default PricingSection; 